export default __webpack_public_path__ + "static/media/66input.94658222.png";